export enum CouponTabsType { //TODOHT for MTS only,  -> ticket tabs
    Ticket,
    CashOut
}